// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum MigrationJobSourceType {
    None = 0,
    Organization = 1,
    BackupJob = 2
}
